import { computed, watch } from 'vue'
import _ from 'lodash'
import log from 'loglevel'
import store from '@/store/index.js'
import { LOCAL_STORAGE_ANALYZE_TRACK_SETTING_KEY } from '@/constants.js'

/**
 * 軌跡マップ表示設定を localStorage に永続化する
 */
export function useStoreAnalyzeTrackSetting() {
  /**
   *  軌跡マップ表示設定(監視用)
   * @type {Object}
   */
  const analyzeTrackSetting = computed(
    () => store.getters['analyzeTrack/settingState']
  )

  /**
   * localStorage から軌跡マップ表示設定を復元する
   * localStorage に値がない場合、測位軌跡のみ個人設定の値で上書きする
   */
  const restoreAnalyzeTrackSettingFromLocalStorage = () => {
    log.debug('[DEBUG] try restore analyze track setting from localStorage')
    const setting = _getAnalyzeTrackSettingFromLocalStorage(
      store.state.login.userId
    )
    if (setting) {
      log.debug('[DEBUG] analyze track setting found in localStorage', setting)
      store.dispatch('analyzeTrack/setSetting', setting)
    } else {
      log.debug(
        '[DEBUG] initialze analyze track setting with member preference'
      )
      store.commit('analyzeTrack/resetState')
      const showLine = store.state.userHistory.historyLineFlg
      store.commit(
        'analyzeTrack/setShowLine',
        showLine.value === showLine.selectValues[0]
      )
    }
  }

  /**
   * localStorageからsettingを取得する
   * @param {Number} userId 対象ユーザーID(未指定時は全取得)
   */
  const _getAnalyzeTrackSettingFromLocalStorage = (userId) => {
    let value = localStorage.getItem(LOCAL_STORAGE_ANALYZE_TRACK_SETTING_KEY)
    try {
      value = JSON.parse(value)
    } catch (e) {
      log.debug('[DEBUG] failed to parse', value, e)
      return null
    }

    if (userId) {
      return value && value[`${userId}`]
    } else {
      return value
    }
  }

  /**
   * localStorageにsetting状態を保存する
   */
  const saveAnalyzeTrackSettingToLocalStorage = () => {
    // Vueのリアクティブ監視プロパティを排除する
    const value = JSON.parse(JSON.stringify(analyzeTrackSetting.value))

    log.debug('[DEBUG] save analyze track setting to localStorage', value)
    localStorage.setItem(
      LOCAL_STORAGE_ANALYZE_TRACK_SETTING_KEY,
      JSON.stringify(
        _mergeAnalyzeTrackSettingToStoraged(store.state.login.userId, value)
      )
    )
  }

  /**
   * localStorageの値に保存したいsetting値をマージする
   * @param {Number} userId ユーザーID
   * @param {Object} setting setting値
   * @returns {Object} マージされたデータ
   */
  const _mergeAnalyzeTrackSettingToStoraged = (userId, setting) => {
    const value = _getAnalyzeTrackSettingFromLocalStorage()
    if (value) {
      return { ...value, [userId]: setting }
    } else {
      return { [userId]: setting }
    }
  }

  // settingに変化があったらlocalStorageに保存
  watch(
    analyzeTrackSetting,
    _.debounce((value) => value && saveAnalyzeTrackSettingToLocalStorage(), 0),
    { deep: true }
  )

  return {
    restoreAnalyzeTrackSettingFromLocalStorage,
    saveAnalyzeTrackSettingToLocalStorage,
  }
}
